import axios from 'axios';
import { useMemo } from 'react';
import useAsync from 'react-use/lib/useAsync';
import { BrandName } from '@packlink/brands';
import { Theme } from '@shipengine/giger-theme';
import { useTenantConfig } from '@packlink/tenant-config-provider';

const FALLBACK_THEME = new Theme();

/**
 * @description Recover theme.json from CDN, until load or in case of error return by default FALLBACK THEME
 */
function useThemeFromCDN(cdnUrl, presetTheme) {
  var _ref, _tenantConfig$brand;
  const tenantConfig = useTenantConfig();
  const brandName = (_ref = tenantConfig === null || tenantConfig === void 0 ? void 0 : (_tenantConfig$brand = tenantConfig.brand) === null || _tenantConfig$brand === void 0 ? void 0 : _tenantConfig$brand.toLowerCase()) !== null && _ref !== void 0 ? _ref : BrandName.FALLBACK;
  const url = useMemo(() => `${cdnUrl}/brand/${brandName}/theme.json`, [brandName, cdnUrl]);
  const {
    value,
    loading
  } = useAsync(() => presetTheme ? Promise.resolve(presetTheme) : fetch(url).then(response => response.json()).then(data => new Theme(data)), [url]);
  return [value || FALLBACK_THEME, loading];
}

/**
 * @description Recover index from CDN. Until load or in case of error return undefined.
 */
function useIconIndexCDN(cdnUrl, presetIcon) {
  const url = useMemo(() => `${cdnUrl}/brand/iconIndex.json`, [cdnUrl]);
  const {
    value,
    loading
  } = useAsync(() => presetIcon ? Promise.resolve(presetIcon) : axios.get(url).then(response => response.data), [url]);
  return [value, loading];
}

export { useIconIndexCDN, useThemeFromCDN };
//# sourceMappingURL=useCDN.js.map
